import React from "react";
import { Typography } from "@mui/material";
import {
  StyledContainer,
  PageTitle,
  ContentSection,
  StyledList,
  InfoBox,
  ImportantNote,
  textStyles,
} from "../../components/common/StyledComponents";

const PelerinajEgipt = () => {
  return (
    <StyledContainer>
      <PageTitle>
        🌿„Scoate-ţi încălţămintea din picioarele tale, că locul pe care calci
        este pământ sfânt.” (Ieșirea 3:5)
      </PageTitle>

      <ContentSection title="Pelerinaj în Egipt și Muntele Sinai">
        <Typography sx={textStyles.regular} mb={2}>
          🇪🇬 Agenția Pelerinul Creștin, cu binecuvântarea Preasfințitului
          Părinte Iustin, organizează în perioada
          <strong> 27 octombrie – 4 noiembrie 2025</strong> un pelerinaj
          duhovnicesc în Egiptul creștin și Muntele Sinai.
        </Typography>
        <Typography sx={textStyles.regular}>
          ⚜️Egiptul – pământ biblic și ținut al sfințeniei, unde Dumnezeu a
          lucrat minuni, iar pustia a rodit sfinți. Este locul unde Sfânta
          Familie s-a adăpostit de prigoana lui Irod, împlinind astfel profeția:
          „Din Egipt am chemat pe Fiul Meu” (Osea 11:1, cf. Matei 2:15).
        </Typography>
        <Typography sx={textStyles.regular} mt={2}>
          ⚜️În deșertul egiptean, pustiul a devenit mănăstire, iar stânca s-a
          preschimbat în altar. Pe Muntele Sinai, Moise a primit Tablele Legii,
          iar focul rugului aprins a vestit o prezență dumnezeiască ce arde, dar
          nu mistuie.
        </Typography>
      </ContentSection>

      <ContentSection title="Popasuri Duhovnicești">
        <StyledList>
          <li>✨ Cairo</li>
          <li>✨ Mănăstirea Sf. Antonie cel Mare</li>
          <li>✨ Mănăstirea Sf. Macarie cel Mare</li>
          <li>✨ Mănăstirea Sf. Mina</li>
          <li>✨ Mănăstirea Sf. Ecaterina</li>
          <li>✨ Muntele Sinai</li>
          <li>✨ Catedrala Sf. Marcu</li>
        </StyledList>
      </ContentSection>

      <ContentSection title="Servicii Incluse">
        <StyledList>
          <li>✨ Zbor Cluj-Napoca – Cairo (dus-întors)</li>
          <li>✨ 8 nopți cazare</li>
          <li>✨ Masă în regim demipensiune</li>
          <li>✨ Transport cu autocarul în Egipt</li>
          <li>✨ Preot însoțitor (Pr. Valeriu Mircea VANA)</li>
          <li>✨ Asigurare medicală</li>
          <li>✨ Croazieră pe Nil și bucurii duhovnicești</li>
        </StyledList>
        <ImportantNote>
          ⚠️ Nu este inclus transportul până la aeroport și tipsurile.
        </ImportantNote>
      </ContentSection>

      <ContentSection title="Detalii și Înscriere">
        <InfoBox>
          <Typography sx={textStyles.regular}>⚜️ Preț: 1200 EURO</Typography>
          <Typography sx={textStyles.regular}>
            📝 Confirmarea locului se face prin achitarea unui avans în maxim 5
            zile de la înscriere.
          </Typography>
          <Typography sx={textStyles.regular}>
            📝 Pentru o bună desfășurare a pelerinajului, grupul va fi format
            din minim 30 persoane.
          </Typography>
          <Typography sx={textStyles.regular}>
            📞 Informații și înscrieri: 0755 182 802
          </Typography>
          <Typography sx={textStyles.regular}>
            🔵 Facebook: Agenția Pelerinul Creștin
          </Typography>
          <Typography sx={textStyles.regular}>
            🌐 Website: www.pelerinulcrestin.ro
          </Typography>
        </InfoBox>
      </ContentSection>

      <Typography sx={{ ...textStyles.bold, mb: 2, textAlign: "center" }}>
        🌿Pelerinaj de suflet pe urmele marilor sfinți ai pustiei, în locuri
        unde Dumnezeu S-a arătat oamenilor și i-a chemat la viață curată și
        rugăciune.
      </Typography>
    </StyledContainer>
  );
};

export default PelerinajEgipt;
